import { observable } from 'mobx';
import dayjs from 'dayjs';
import { ChannelTask, TaskScope } from '../model';

class TaskCenterStore {
  @observable minWidth = 90;
  @observable teamId = [];
  // 记录首次打开面板teamId
  @observable oldTeamId = [];
  @observable open = false;
}
class TaskCenterTeamStore {
  @observable minWidth = 90;
  @observable teamId = [];
  // 记录首次打开面板teamId
  @observable oldTeamId = [];
  @observable open = false;
}
class TaskStore {
  @observable remark = '';
  @observable organizationTree = [];
  @observable remarkShow = false;
  @observable sortBy = {
    order_by: 'END_DATE',
    sort: 'DESC',
  };

  @observable taskGroupDetails=[];
  @observable getGroupTaskList=[];
  @observable getGroupConfig={
    page: 1,
    page_size: 10,
    total_num: null,
    total_page: null,
  };
  @observable getTeamGroupConfig={
    page: 1,
    page_size: 10,
    total_num: null,
    total_page: null,
  };
  @observable taskDetails: ChannelTask = {} as ChannelTask;
  @observable todoUserListLoading = true;
  @observable todoUserDetailListLoading = true;
  @observable TaskCenterStore = new TaskCenterStore();
  @observable TaskCenterTeamStore = new TaskCenterTeamStore();

  @observable group = ''; // 不能设置默认值，否则会先初始化默认页面，再切换到目标页面
  @observable scope = TaskScope.personal;
  @observable activeCount: Record<string, any> = {
    personal: {},
    team: {},
  };
  @observable taskTypeList = [];
  @observable taskTypeGroup = {};
}

export default new TaskStore();
